import { useMutation } from "@apollo/client";
import React, { useCallback } from "react";

import { TrackingOptInMutation, TrackingOptOutMutation } from "../../../../../__generated__/graphql";
import { ACCEPT_TRACKING_MUTATION, REJECT_TRACKING_MUTATION } from "../../../graphql/mutations";
import Alert from "../../design-system/Alert";
import { ExternalLink } from "../../design-system/Button/Link";
import styles from "../../design-system/Toaster/styles.module.scss";

export default function AnalyticsOptInControlAlert() {
  const [optIn, { called: optInCalled }] = useMutation<TrackingOptInMutation>(ACCEPT_TRACKING_MUTATION);
  const [optOut, { called: optOutCalled }] = useMutation<TrackingOptOutMutation>(REJECT_TRACKING_MUTATION);

  const clickOptIn = useCallback(() => optIn(), [optIn]);
  const clickOptOut = useCallback(() => optOut(), [optOut]);

  if (optInCalled || optOutCalled) {
    return null;
  }

  return (
    <Alert
      className={styles.toastAlert}
      actions={[
        { variant: "secondary", onClick: clickOptOut, label: "Decline" },
        { variant: "secondary", onClick: clickOptIn, label: "Accept" },
      ]}
    >
      We would like to set analytics cookies to help us improve the dashboard by collecting and reporting on information
      about how you use it. For more information, please see{" "}
      <ExternalLink to="https://www.culture-shift.co.uk/dashboard-privacy-notice/">
        the Culture Shift privacy notice
      </ExternalLink>
      .
    </Alert>
  );
}
